import React from 'react';

import {Paper, Table, TableContainer, makeStyles} from '@material-ui/core';

import Provider from './Provider';
import DTableHead from './DTableHead';
import DTableBody from './DTableBody';
import DTableFooter from './DTableFooter';
import DTableToolbar from './DTableToolbar';

const useStyles = makeStyles(theme => ({
    tableData: {
        overflowX: 'auto',
    },
    container: {
        padding: 0,
        '& h6': {
            margin: 0,
        },
    },
}));

export default function DataTable({
    title,
    children,
    data,
    options = {},
    tableRef = null,
    initialFetchOptions, // for uncontrolled
    fetchOptions,
    onChangeFetchOptions, // for controlled
    editable,
    ...props
}) {
    const classes = useStyles();
    return (
        <Provider
            data={data}
            options={options}
            tableRef={tableRef}
            initialFetchOptions={initialFetchOptions}
            fetchOptions={fetchOptions}
            onChangeFetchOptions={onChangeFetchOptions}
            editable={editable}
        >
            {children}
            <TableContainer component={Paper} className={classes.container}>
                <DTableToolbar title={title} />
                <div className={classes.tableData}>
                    <Table {...props}>
                        <DTableHead />
                        <DTableBody />
                    </Table>
                </div>
                <Table {...props}>
                    <DTableFooter />
                </Table>
            </TableContainer>
        </Provider>
    );
}
